<template>
  <input type="text" class="rew19_inputTxt_t1" :readonly="readOnly"/>
</template>
<script>
export default {
  name: "DatePicker",
  components: {  },
  computed: {},
  props: {
    dateFormat: {
      type: String,
      default: "yy.mm.dd"
    },
    date:{
      type: String,
      default: null
    },
    readOnly:{
      type : Boolean,
      default: false
    } 
  },
  data() { 
    return {};
  },
  created() {
  },
  beforeDestroy(){
    var _this = this;
    $(_this.$el).datepicker('hide').datepicker('destroy');
  },
  mounted() {
    var _this = this;

    $(this.$el).datepicker({
      dateFormat: _this.dateFormat,
      defaultDate : _this.date,
      onSelect: function(d){
        _this.$emit('update-date',d)
      }
    });
  },
  methods: {
    setDate(d){
      var _this = this;
      $(_this.$el).datepicker("setDate", d);
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/control/DatePicker.vue